import { render, staticRenderFns } from "./UserGuidePrintingAndShipping.vue?vue&type=template&id=755b21e6&"
import script from "./UserGuidePrintingAndShipping.vue?vue&type=script&lang=ts&"
export * from "./UserGuidePrintingAndShipping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports